// extracted by mini-css-extract-plugin
export default {"labelContainer":"FieldCustomerName_labelContainer__HXJ5i"};